import React from 'react';
import { Newspaper, Calendar, Briefcase, Building2, File, DollarSign, ExternalLink } from 'lucide-react';
import { IconRendererProps } from './types';

export function IconRenderer({ type, icon, bg_color, text_color }: IconRendererProps) {
  if (type === 'service' || type === 'quicklink') {
    if (icon) {
      return (
        <div className={`p-2 rounded-lg mr-4 ${bg_color || 'bg-purple-50  dark:bg-gray-800'}`}>
          <span className={`text-xl ${text_color || 'text-purple-500'}`}>{icon}</span>
        </div>
      );
    }
  }

  // Default icons for each type
  switch (type) {
    case 'news':
      return <div className="p-2 rounded-lg bg-gray-50 dark:bg-gray-800"><Newspaper className="w-5 h-5 text-blue-500" /></div>;
    case 'event':
      return <div className="p-2 rounded-lg bg-gray-50 dark:bg-gray-800"><Calendar className="w-5 h-5 text-green-500" /></div>;
    case 'service':
      return <div className="p-2 rounded-lg bg-gray-50 dark:bg-gray-800"><Briefcase className="w-5 h-5 text-purple-500" /></div>;
    case 'quicklink':
      return <div className="p-2 rounded-lg bg-gray-50 dark:bg-gray-800"><ExternalLink className="w-5 h-5 text-purple-500" /></div>;
    case 'department':
      return <div className="p-2 rounded-lg bg-gray-50 dark:bg-gray-800"><Building2 className="w-5 h-5 text-orange-500" /></div>;
    case 'document':
      return <div className="p-2 rounded-lg bg-gray-50 dark:bg-gray-800"><File className="w-5 h-5 text-indigo-500" /></div>;
    case 'bidding':
      return <div className="p-2 rounded-lg bg-yellow-50 dark:bg-gray-800 mr-4"><DollarSign className="w-5 h-5 text-yellow-500" /></div>;
    default:
      return <div className="p-2 rounded-lg bg-gray-50 dark:bg-gray-800"><Newspaper className="w-5 h-5 text-blue-500" /></div>;
  }
}